<template>
  <div>
    <div style="padding-left: 5px;" class="app-container">
      <el-tabs v-model="activeName" @tab-click="handleClicktab">
        <el-tab-pane label="入库记录" name="first" :lazy="true">
          <div v-if="activeName=='first'">
            <div class="formBox margbot" ref="searchBox">
          <el-form :inline="true" :model="formData" label-width="90px" size="mini">
            <div class="formItemBox">
            <el-form-item label="入库单号:">
              <el-input v-model="formData.instockNo" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="车辆牌号:">
              <el-input v-model="formData.instockPlateNumber" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="一级货主:">
              <el-select filterable clearable placeholder="请选择" v-model="formData.primaryCustomerTaxId">
                <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-select clearable filterable placeholder="请选择" v-model="formData.customerTaxId">
                <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货物类型:">
              <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable>
                <el-option
                  v-for="(item, index) in productTypeData"
                  :key="index"
                  :label="item.productTypeName"
                  :value="item.productType"
                >
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in steelMillNameData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in specificationData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in modelData"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="入库日期:" >
              <div style="display: flex;">
                <el-date-picker v-model="formData.instockDateStart" type="datetime" placeholder="请选择"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                -
                <el-date-picker v-model="formData.instockDateEnd" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="到货方式:">
            <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable>
              <el-option
                v-for="(item, index) in arrivalMethodData"
                :key="index"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
              </el-select>
          </el-form-item>
            <el-form-item label="车船编号:">
              <el-input v-model="formData.plateNumber" placeholder="请输入车船号" ></el-input>
            </el-form-item>
            </div>
            <el-form-item style="margin-left:10px;">
              <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP00BB001" v-if="btnFlg[0]">查询</el-button>
              <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP00BB002" v-if="btnFlg[1]">重置</el-button>
              <el-button type="primary" size="mini" @click="daochu" btnCode="00cP00BB003" v-if="btnFlg[2]">导出</el-button>
              <el-button type="primary" size="mini" @click="shanchu" btnCode="00cP00BB004" v-if="btnFlg[3]">删除</el-button>
            </el-form-item>
            <div ref="searchBox2" style="margin-top: 0;margin-bottom:5px;margin-left:10px;">
              <span>
                总吨数:
                <span style="color: red">{{totalAllWeight}}</span> &nbsp;吨
              </span>
              <span style="margin-left: 15px">
                总件数:
                <span style="color: red">{{ totalNumber }}</span> &nbsp;件
              </span>
            </div>
          </el-form>
        </div>
        <div :style="{height:h}">
          <el-table
          border
          center
          bordersize="mini"
          :data="tableData"
          height="100%"
          style="width:100%"
          size="mini"
          highlight-current-row
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          @selection-change="selectGoods"
          >
            <el-table-column type="selection" align="center" width="40"></el-table-column>
            <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
            <el-table-column align="center" label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="text"  @click="lookImg(scope.row)" size="mini">查看单据</el-button>
                <el-button type="text"  @click="guoBangClick(scope.row)" size="mini">过磅记录</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="organizationName" label="仓库名称" width="170" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库时间" width="180" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="instockUser" label="入库人" width="100" ></el-table-column>
            <el-table-column prop="arrivalMethod" label="到货方式" align="center" width="100"></el-table-column>
            <el-table-column prop="plateNumber" label="车船号" width="120" ></el-table-column>
            <el-table-column prop="instockPlateNumber" label="车号" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220" ></el-table-column>
            <el-table-column prop="productTypeName" label="货物类型" width="120" ></el-table-column>
            <el-table-column prop="steelMillName" label="产地" width="100" ></el-table-column>
            <el-table-column prop="specification" label="规格" width="150" ></el-table-column>
            <el-table-column prop="model" label="材质" width="120" ></el-table-column>
            <el-table-column prop="number" label="件数" width="70" ></el-table-column>
            <el-table-column prop="allWeight" label="总重量（吨）" width="120" ></el-table-column>
            <el-table-column prop="weight" label="理重（吨）" width="120" ></el-table-column>
            <el-table-column prop="weighingWeight" label="过磅净重（吨）" width="120" ></el-table-column>
            <el-table-column prop="weighingDate" label="过磅净重时间" width="180" ></el-table-column>
            <el-table-column prop="factoryWeight" label="出厂过磅净重（吨）" width="170" ></el-table-column>
            <el-table-column prop="grossWeight" label="毛重（吨）" width="110" ></el-table-column>
            <el-table-column prop="tareWeight" label="皮重（吨）" width="110" ></el-table-column>
            <el-table-column prop="warehouseName" label="仓位" width="120" ></el-table-column>
            <el-table-column prop="instockNo" label="入库单号" width="220" ></el-table-column>
            <el-table-column prop="shipForecastNo" label="预报编号" width="220" ></el-table-column>
            <el-table-column prop="driverName" label="司机" width="150" ></el-table-column>
            <el-table-column prop="telephone" label="司机电话" width="180" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200" ></el-table-column>
            <el-table-column prop="sceneUser" label="现场人员" width="120" ></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="ext1" label="备注" align="center" width="150"></el-table-column>
          </el-table>
        </div>
        <div class="pags" >
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            :page-sizes="[10,20,30,40,50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            :total="total"
          ></el-pagination>
        </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="进仓记录" name="second" :lazy="true">
          <jc-record v-if="JCVisible && activeName=='second'" :JCVisible.sync="JCVisible"></jc-record>
        </el-tab-pane>
        <el-tab-pane label="出库记录" name="third" :lazy="true">
          <ck-record v-if="CKVisible && activeName=='third'" :CKVisible.sync="CKVisible"></ck-record>
        </el-tab-pane>
        <el-tab-pane label="转货记录" name="fourth" :lazy="true">
          <zh-record v-if="ZHVisible && activeName=='fourth'" :ZHVisible.sync="ZHVisible"></zh-record>
        </el-tab-pane>
        <el-tab-pane label="移库记录" name="fifth" :lazy="true">
          <yk-record v-if="YKVisible && activeName=='fifth'" :YKVisible.sync="YKVisible"></yk-record>
        </el-tab-pane>
        <el-tab-pane label="亏涨记录" name="sixth" :lazy="true">
          <kh-record v-if="KHVisible && activeName=='sixth'" :KHVisible.sync="KHVisible"></kh-record>
        </el-tab-pane>
        <!-- <el-tab-pane label="仓位亏涨记录" name="seventh" :lazy="true">
          <cw-record v-if="CWVisible && activeName=='seventh'" :CWVisible.sync="CWVisible"></cw-record>
        </el-tab-pane> -->
        <el-tab-pane label="删除记录" name="eighth" :lazy="true">
          <sc-record v-if="SCVisible && activeName=='eighth'" :SCVisible.sync="SCVisible"></sc-record>
        </el-tab-pane>
        <el-tab-pane label="撤销记录" name="ninth" :lazy="true">
          <cx-record v-if="CXVisible && activeName=='ninth'" :CXVisible.sync="CXVisible"></cx-record>
        </el-tab-pane>
        <el-tab-pane label="入库过磅记录" name="tenth" :lazy="true">
          <rkgb-record v-if="RuKuGBVisible && activeName=='tenth'" :RuKuGBVisible.sync="RuKuGBVisible"></rkgb-record>
        </el-tab-pane>
        <el-tab-pane label="出库过磅记录" name="eleven" :lazy="true">
          <ckgb-record v-if="ChuKuGBVisible && activeName=='eleven'" :ChuKuGBVisible.sync="ChuKuGBVisible"></ckgb-record>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 查看单据 -->
    <dj-dialog v-if="CKDJVisible" :CKDJVisible.sync='CKDJVisible' :instockId="instockId"></dj-dialog>
    <!-- 过磅记录 -->
    <gBJiLu-dialog v-if="guoBangVisible" :guoBangVisible.sync='guoBangVisible' :instockSummaryId="instockSummaryId"></gBJiLu-dialog>
  </div>
</template>

<script>
import { getRelationCustomer, getVirtualBalingList, JfgetInStockExpList, JfdeleteInStockExp, getInStockExpNumber } from '@/api/wms-stock'
import { } from '@/api/wms-access'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
import JcRecord from './JCRecord.vue'
import CkRecord from './CKRecord.vue'
import ZhRecord from './ZHRecord.vue'
import YkRecord from './YKRecord.vue'
import KhRecord from './KHRecord.vue'
import CwRecord from './CWRecord.vue'
import ScRecord from './SCRecord.vue'
import CxRecord from './CXRecord.vue'
import rkgbRecord from './RuKuGBRecord.vue'
import ckgbRecord from './ChuKuGBRecord.vue'
import djDialog from '../../yycRuKu/yycChuanYun/dialog/DJindex.vue'
import gBJiLuDialog from '../../yycRuKu/gBJiLuDialog.vue'
export default {
  components: { JcRecord, CkRecord, ZhRecord, YkRecord, KhRecord, CwRecord, ScRecord, CxRecord, djDialog, rkgbRecord, ckgbRecord, gBJiLuDialog },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      total: 0,
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      formData: {
        instockNo: '',
        instockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        instockDateStart: '',
        instockDateEnd: '',
        arrivalMethod: '',
        plateNumber: ''
      },
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      btnArr: [
        // 入库记录
        '00cP00BB001',
        '00cP00BB002',
        '00cP00BB003',
        '00cP00BB004',
        // 进仓记录
        '00cP00BB005',
        '00cP00BB006',
        '00cP00BB007',
        // 出库记录
        '00cP00BB008',
        '00cP00BB009',
        '00cP00BB00A',
        '00cP00BB00B',
        // 转货记录
        '00cP00BB00C',
        '00cP00BB00D',
        '00cP00BB00E',
        '00cP00BB00F',
        // 移库记录
        '00cP00BB00G',
        '00cP00BB00H',
        '00cP00BB00I',
        // 亏涨记录
        '00cP00BB00J',
        '00cP00BB00K',
        '00cP00BB00L',
        // 删除记录
        '00cP00BB00M',
        '00cP00BB00N',
        '00cP00BB00O',
        // 撤销记录
        '00cP00BB00P',
        '00cP00BB00Q',
        '00cP00BB00R',
        // 入库过磅记录
        '00cP00BB00S',
        '00cP00BB00T',
        '00cP00BB00U',
        '00cP00BB00V',
        '00cP00BB00W',
        '00cP00BB00X',
        // 出库过磅记录
        '00cP00BB00Y',
        '00cP00BB00Z',
        '00cP00BB00a',
        '00cP00BB00b',
        '00cP00BB00c',
        '00cP00BB00d'
      ],
      btnFlg: [],
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      selectListId: [],
      selectList: [],
      JCVisible: true,
      CKVisible: true,
      ZHVisible: true,
      YKVisible: true,
      KHVisible: true,
      CWVisible: true,
      SCVisible: true,
      CXVisible: true,
      RuKuGBVisible: true,
      ChuKuGBVisible: true,
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      CKDJVisible: false,
      instockId: '',
      guoBangVisible: false,
      instockSummaryId: '',
      totalAllWeight: 0,
      totalNumber: 0
    }
  },
  methods: {
    // 点击过磅记录
    guoBangClick (row) {
      this.guoBangVisible = true
      this.instockSummaryId = Number(row.instockSummaryId)
    },
    // 查看单据
    lookImg (row) {
      this.CKDJVisible = true
      this.instockId = row.instockId
    },
    handleClicktab (tab, event) {
      // this.getControlAuditLists()
      this.chongzhi()
    },
    timeStamp: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    getNowTime () {
      let newTime = this.timeStamp(new Date())
      this.formData.instockDateEnd = newTime
      this.formData.instockDateStart = this.timeStamp(new Date(newTime).getTime() - (86400000 * 3))
      this.JfgetInStockExpLists()
    },
    getInStockExpNumber () {
      getInStockExpNumber(
        {
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          instockNo: this.formData.instockNo,
          instockPlateNumber: this.formData.instockPlateNumber,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          instockDateStart: this.formData.instockDateStart,
          instockDateEnd: this.formData.instockDateEnd,
          arrivalMethod: this.formData.arrivalMethod,
          plateNumber: this.formData.plateNumber
        }
      )
        .then(res => {
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 列表查询
    JfgetInStockExpLists () {
      JfgetInStockExpList(
        {
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          instockNo: this.formData.instockNo,
          instockPlateNumber: this.formData.instockPlateNumber,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          instockDateStart: this.formData.instockDateStart,
          instockDateEnd: this.formData.instockDateEnd,
          arrivalMethod: this.formData.arrivalMethod,
          plateNumber: this.formData.plateNumber
        }
      )
        .then(res => {
          this.tableData = res.list
          this.total = res.total
          this.getInStockExpNumber()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.inDetailId) // id数组
        arry = Array.from(new Set(arry)) // 去重
        this.selectListId = arry.join(',') // 获取全部货物id
      })
    },
    shanchu () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.selectList.length == 0) {
        DonMessage.error('请先选择一条数据')
        return
      } else if (this.selectList.length > 1) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.$confirm('删除后数据不可恢复，确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        JfdeleteInStockExp({
          instockSummaryId: this.selectList[0].instockSummaryId
        })
          .then(res => {
            DonMessage.success('删除成功')
            this.JfgetInStockExpLists()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    chaxun () {
      this.JfgetInStockExpLists()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.instockNo = ''
      this.formData.instockPlateNumber = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.customerTaxId = ''
      this.formData.arrivalMethod = ''
      this.formData.plateNumber = ''
      this.getNowTime()
      this.getVirtualBalingList()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportInStockExpList',
        { ...this.formData, instockStatus: '1' },
        '入库记录信息表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetInStockExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetInStockExpLists()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
      })
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  },
  updated () {
    var _this = this
    if (_this.activeName == 'first') {
      document.onkeydown = function (e) {
        let key = window.event.keyCode
        if (key == 13) {
          _this.chaxun()
        }
      }
    }
  },
  created () {
    this.getNowTime()
    this.btnFlg = getBtn(this.btnArr, '/yycJiLuChaXun')
    this.getRelationCustomerS()
    this.getVirtualBalingList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 202 + 'px'
  }
}
</script>

<style lang="less" scoped>
   /deep/.el-tabs__header {
  margin: 0;
}
.inpBox{
  /deep/ .el-form-item{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
</style>
